"use client";

import { ReactNode, useContext, useEffect } from "react";
import { ConfigProvider, theme as antdTheme } from "antd";
import { Toaster } from "react-hot-toast";
import { Provider as ApolloProvider } from "@/client/apolloClient";
import { CMSContext, CMSModal } from "@/context";
import "@/i18n/config";
import { useTranslation } from "react-i18next";

export default function Providers({ children }: { children: ReactNode }) {
    const { theme } = useContext(CMSModal);
    const { i18n } = useTranslation();

    const isRTL = i18n.language === "ar" || i18n.language === "he";

    useEffect(() => {
        document.documentElement.dir = isRTL ? "rtl" : "ltr";
        document.documentElement.lang = i18n.language;
    }, [i18n.language, isRTL]);

    return (
        <ApolloProvider>
            <ConfigProvider
                direction={isRTL ? "rtl" : "ltr"}
                theme={{
                    algorithm:
                        theme === "dark"
                            ? antdTheme.darkAlgorithm
                            : antdTheme.defaultAlgorithm,
                    token: {
                        colorBgElevated: theme === "dark" ? "#262727" : "#ffffff",
                        colorText: theme === "dark" ? "#ffffff" : "#000000",
                    },
                }}
            >
                <Toaster />
                {children}
            </ConfigProvider>
        </ApolloProvider>
    );
}
